import { createFileRoute, redirect } from '@tanstack/react-router';
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { spSiteContext } from '../sp-site-context/sp-site-context';
import { getUser } from '../store/userStore';

export const Route = createFileRoute('/no-site')({
    beforeLoad: async () => {
        const user = getUser();
        if (user && (await spSiteContext.get(user.siteUrl))) {
            throw redirect({ to: '..' });
        }
    },
    component: () => (
        <MessageBar intent="warning" style={{ alignSelf: 'start', margin: '0 auto' }}>
            <MessageBarBody>
                <MessageBarTitle>Fehlende Informationen.</MessageBarTitle>
                Bitte starten Sie die Anwendung aus einer SharePoint-Seite.
            </MessageBarBody>
        </MessageBar>
    ),
});
